<script>
export default {
    name: "IndividualItems",
    data() {
        return {
            productOrderId: null,
            productionItems: [],
            paginationParams: {
                page: 1,
                sorts: [{ columnName: "id", type: "asc" }],
                perPage: 200,
                status: 'all',
            },
            hasMoreItems: false,
        }
    },
    mounted() {
       this.getItemsInProduction()
    },
    methods: {
        searchProductionItems(productOrderId) {
            this.productOrderId = productOrderId;
            this.getProductOrderData();
        },
        async getProductOrderData() {
            this.error = null;
            this.resetPage()
            try {
                let res = await axios.get("product_orders/details/" + this.productOrderId);
                this.productionItems = res.data.data.items;
                this.totalRows = this.productionItems.length;
            } catch (error) {
                this.error = "Product order not found";
            }
        },
        async printProductionSheet(item) {
            await ezy.openPDFInNewWindow(`production_items/production_sheet/${item.id}`)
        },
        async printPattern(item) {
            item.is_pattern_printed = true;
            await ezy.openPDFInNewWindow(`product_orders/pattern/${item.product_order_id}`)
        },
        async getItemsInProduction() {
            this.error = null;

            try {
                let result = await axios.get("production_items/listing", {
                    params: this.paginationParams
                });
                this.totalRows = result.data.data.total;
                let productionItems = result.data.data.data;
                productionItems.forEach((item) => {
                    this.productionItems.push(item);
                })
                this.hasMoreItems = result.data.data.current_page < result.data.data.last_page
            } catch (error) {
            }
        },

        resetPage() {
            this.paginationParams.page = 1;
            this.productOrders = [];
        },
        loadMoreItems() {
            this.paginationParams.page++
            this.getItemsInProduction()
        },
        getFormattedConfiguration(configuration, color) {
            if(!configuration) return '';
            let formattedConfiguration = [];

            if(color) {
                formattedConfiguration.push(`Color: ${color}`)
            }

            for (const [key, value] of Object.entries(configuration)) {
                let label = key;
                switch (key) {
                    case 'fabric_id':
                        label = 'Fabric';
                        break;
                    case 'contrast_fabric_id':
                        label = 'Contrast';
                        break;
                    case 'length':
                        label = 'Length';
                        break;
                    case 'size':
                        label = 'Size';
                        break;
                    case 'version':
                        label = 'Version';
                        break;
                }
                if(value != 0) {
                    formattedConfiguration.push(`${label}: ${value}`)
                }
            }
            return formattedConfiguration.join('<br/>')
        }
    }
}
</script>

<template>
    <div class="grid bg-white">
        <div class="grid-title">
            <h5 class="text-bold">Individual Order Items</h5>
        </div>
        <div class="grid-body">
            <div id="product-orders-overview-top-navigation" class="row justify-content-between">
                <div class="col-md-4">
                    <input
                        type="text"
                        placeholder="Enter the Product Order ID ..."
                        class="form-control"
                        @keyup.enter="searchProductionItems($event.target.value)"/>
                </div>
            </div>
        </div>
        <div class="grid-body" v-if="productionItems.length > 0">
            <table id="productOrder-detail-table" class="table table-bordered">
                <thead>
                <tr>
                    <th>Item ID</th>
                    <th>Product</th>
                    <th class="configuration-header">Configuration</th>
                    <th>Status</th>
                    <th>Days in Status</th>
                    <th>Age</th>
                    <th class="text-center">Documents</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in productionItems" :key="item.id">
                    <td class="text-bold">
                        #{{ item.id }}
                    </td>
                    <td>{{ item.product_name }}</td>
                    <td v-html="getFormattedConfiguration(item.configuration, item.color)"></td>
                    <td>
                        <router-link
                        :to="{ name: 'product_order_details', params: { id: item.product_order_id } }"
                        :class="'item-status ' + item.status"
                        >
                          {{ item.id }} | {{ item.status }}
                        </router-link>
                    </td>
                    <td class="text-center">{{ item.days_in_status }}</td>
                    <td class="text-center">{{ item.age }}</td>
                    <td class="text-bold text-center">
                        <a
                            v-if="item.can_print_production_sheet"
                            @click="printProductionSheet(item)"
                            :class="{
                                'btn btn-primary btn-sm': !item.is_production_sheet_printed,
                                'btn btn-success btn-sm': item.is_production_sheet_printed,
                           }"
                        >
                            Print Production Sheet
                        </a>
                        <span v-else class="btn btn-sm btn-disabled">Print Production Sheet</span>
                        <a  v-if="item.can_print_pattern"
                           @click="printPattern(item)"
                           :class="{
                            'btn btn-primary btn-sm': !item.is_pattern_printed,
                            'btn btn-success btn-sm':
                              item.is_pattern_printed,
                          }"
                        >
                            Print Pattern
                        </a>
                        <span v-else class="btn btn-sm btn-disabled">Print Pattern</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="hasMoreItems" class="text-center">
                <span @click="loadMoreItems" class="items-loader">Load more items ...</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .items-loader {
        cursor: pointer;
        font-weight: 600;
    }
    .configuration-header {
        min-width: 200px;
    }
</style>
